import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  AutoComplete,
  DatePicker,
  Space,
  Button,
  Tag,
  Input,
  Row,
  Col,
  Pagination,
  Typography,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import api from "utils/api";
import utils from "utils";
import { IconSearch, IconPrint, IconEdit } from "Common/ReactIcons";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import AutoCompleteDebounce from "Components/AutoCompleteDebounce";
import VendorDetailForm from "./VendorDetailForm";
const columnName = {
  vendor_id: "Vendor Id",
  contact: "Contact",
  name: "Vendor",
  contact_number: "Contact No.",
  contact_name: "Contact Name",
  email_id: "E-mail",
  address: "Address",
  action: " ",
};

const MyTableComponent = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchOptions, setSearchOptions] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({
    billStatus: null,
    paymentStatus: null,
    paymentMode: null,
  });
  const [issearchLoading, setIsSearchLoading] = useState(false);
  const history = useHistory();
  // const billingIDObject = useRef({});
  const fetchData = async (params = {}) => {
    setLoading(true);
    const { searchValue, filters, pagination } = params;

    // Construct query parameters
    const query = new URLSearchParams({
      patient_vendor_id:
        // searchValue.title == "contact_number" || searchValue.title == "name"
        //   ?
        searchValue.patient_vendor_id || "",
      //   : ""
      // search: searchValue || "",
      page: pagination.current || 1,
      page_size: pagination.pageSize || 10,
    }).toString();

    try {
      const response = await api.listVendorDetails(query);
      if (response.data.status === 200 && response.data.message === "success") {
        const { results, count } = response.data.data;
        setData([]);
        let transResult = results.map((item, index) => ({
          ...item,
          key: index,
        }));
        setData(transResult);
        setPagination({
          ...pagination,
          total: count,
        });
      } else {
        console.error("Failed to fetch data: unexpected response format");
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1, pageSize: 10 }));
    fetchData({
      searchValue,
      filters,
      pagination: { current: 1, pageSize: 10 },
    });
  }, [searchValue, filters]);

  const handleTableChange = (filters) => {
    // setPagination(pagination);
    setFilters({
      billStatus: filters.bill_status ? filters.bill_status : null,
      paymentStatus: filters.payment_status ? filters.payment_status : null,
      paymentMode: filters.payment_mode ? filters.payment_mode : null,
    });
  };
  const renderTitle = (title) => <span>{columnName[title]}</span>;
  const renderItem = (item, index, parentindex, title) => {
    // billingIDObject.current[search_value] = billing_id;
    return {
      key: `${title} ${index}`,
      value:
        title == "order_number" || title == "bill_number"
          ? item.search_value
          : item.patient_vendor_id,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {item.search_value}
          <span>
            <UserOutlined /> {item.patient_vendor_id}
          </span>
        </div>
      ),
      patient_vendor_id: item.patient_vendor_id,
      billing_id: item.billing_id,
      title: title,
    };
  };
  const handleSearchChange = async (value) => {
    if (value) {
      setIsSearchLoading(true);
      try {
        const query = new URLSearchParams({ search: value }).toString();
        const response = await api.fetchVendorDetailsSearch(query);
        if (
          response.data.status === 200 &&
          response.data.message === "success"
        ) {
          const { results, count } = response.data.data;
          if (count > 0) {
            const options = Object.keys(results).map(
              (objectKey, parentindex) => ({
                key: objectKey,
                label: renderTitle(objectKey),
                options: results[objectKey].map((item, index) =>
                  renderItem(item, index, parentindex, objectKey)
                ),
              })
            );
            setSearchOptions(options);
          }
        } else {
          console.error("Failed to fetch data: unexpected response format");
        }
      } catch (error) {
        console.error("Failed to fetch search options:", error);
      } finally {
        setIsSearchLoading(false);
      }
    } else {
      setSearchValue("");
      setSearchOptions([]);
    }
  };
  const refreshVendorList = () => {
    fetchData({
      searchValue,
      filters,
      pagination: { current: 1, pageSize: 10 },
    });
  };
  const formatNumberWithCommas = (number) => {
    return number.toLocaleString("en-IN");
  };
  const columns = [
    {
      title: columnName.name,
      dataIndex: "name",
      key: "name",
      width: 220,
      render: (text, record) => (
        <>
          <div>{text}</div>
          <div className="sub-text">{record?.patient_vendor_id}</div>
          <div className="sub-text-2">{record?.GSTIN_number}</div>
        </>
      ),
    },
    {
      width: 180,
      title: columnName.contact,
      dataIndex: "contact_number",
      key: "contact_number",
      render: (text, record) => (
        <>
          <div>{record?.contact_name}</div>
          {text && (
            <div className="sub-text">{`${record?.country_code} ${text}`}</div>
          )}
        </>
      ),
    },
    {
      title: columnName.email_id,
      dataIndex: "email_id",
      key: "email_id",
    },
    {
      title: columnName.address,
      dataIndex: "address",
      key: "address",
      width: 120,
      render: (text, record) => (
        <Typography.Text
          style={{width:200}}
          ellipsis={{ rows: 2, tooltip: { title: text, placement: "top" } }}
        >
          {text}
        </Typography.Text>
      ),
    },
    {
      // title: "Action",
      title: " ",
      key: "action",
      align: "right",
      render: (text, record) => (
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "2px" }}
        >
          <Button
            type="link"
            onClick={() => {
              history.push(`${props.user_details.baseUrl}/billing`, {
                selectedTab: "newBill",
                VendorDetail: record,
              });
            }}
          >
            <span>Add New Bill</span>
          </Button>
          <Button
            type="link"
            onClick={() => {
              history.push(`${props.user_details.baseUrl}/billing`, {
                selectedTab: "billingHistory",
                VendorDetail: record,
              });
            }}
          >
            <span>View Bill History</span>
          </Button>
          <Button
            type="link"
            icon={<IconEdit />}
            onClick={() => {
              utils.Modal(true, {
                content: (
                  <VendorDetailForm
                    initialValues={record}
                    title={"Edit Vendor"}
                    refreshVendorList={refreshVendorList}
                  />
                ),
                width: "500px",
                closable: false,
              });
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="vendor-table">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <AutoCompleteDebounce
          options={searchOptions}
          style={{
            // width:"363px",
            // height:"48px",
            padding: "0px 24px 0px 0px",
          }}
          // dropdownStyle={{ width: "360px", }}
          onSelect={(value, option) => setSearchValue(option)}
          onSearch={handleSearchChange}
          // dropdownMatchSelectWidth={true}
          loading={issearchLoading}
        >
          <Input
            prefix={<IconSearch />}
            style={{ height: "100%", width: "412px" }}
            // value={searchValue}
            // onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Search by VID/Vendor Name/Contact Name/Contact No./Email"
          />
        </AutoCompleteDebounce>
        <Button
          style={{ background: "rgb(18, 0, 95)", color: "white" }}
          onClick={() => {
            utils.Modal(true, {
              content: (
                <VendorDetailForm refreshVendorList={refreshVendorList} />
              ),
              width: "500px",
              closable: false,
            });
          }}
        >
          <span>Add Vendor</span>
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        onChange={handleTableChange}
        rowKey="order_number"
        pagination={false}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Pagination
          current={pagination.current || 1}
          pageSize={pagination.pageSize || 10}
          pageSizeOptions={[5, 10, 15, 20, 50, 100]}
          total={pagination.total}
          showSizeChanger
          showTotal={(total) => `Total ${pagination.total} items`}
          onChange={(current, pageSize) => {
            setPagination((prev) => ({ ...prev, current, pageSize }));
            fetchData({
              searchValue,

              filters,
              pagination: { current, pageSize },
            });
          }}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(MyTableComponent);
